import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles.css';

import { Button, TextInput } from '@components';

import { Field, Formik } from 'formik';
import { object, string } from 'yup';

import { toast } from 'react-toastify';
import { encryptionPassword } from '../../../../common/cryptography/encrypt';
import insereDadosUsuario from '../../../../store/modules/recuperacaoSenha/actions';
import api from '../../../../common/services/api';
import { LOGIN } from '../../../../common/utils/paths';

export const InsereNovaSenha = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dadosUsuario = useSelector((state) => state.recuperacaoSenha);

  const [senhasDivergentes, setSenhasDivergentes] = useState('');

  const alteraSenha = async (novaSenha) => {
    const { matricula } = dadosUsuario;
    const { token } = dadosUsuario;
    const cryptoPassword = await encryptionPassword(
      matricula,
      novaSenha,
      token
    );

    const response = await api
      .post('AtualizaSenha', {
        matricula,
        token,
        senha: cryptoPassword,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        console.error('Erro ao atualizar senha:', err);
        return err;
      });

    return response;
  };

  const submitMatricula = async (values) => {
    if (values.senha1 === values.senha2) {
      const response = await alteraSenha(values.senha1);

      if (response.data[0].linhasafetadas === 1) {
        dispatch(
          insereDadosUsuario({
            email: undefined,
            telefone: undefined,
            matricula: undefined,
            token: undefined,
            etapa: undefined,
          })
        );
        toast.success('Senha alterada com sucesso');
        navigate(LOGIN);
        return;
      }
      toast.error('Ocorreu um erro, tente novamente');
    }
    setSenhasDivergentes('As senhas digitadas não são iguais');
  };

  const matriculaSchema = object({
    senha1: string()
      .required('A senha é obrigatória')
      .min(6, 'No mínimo 6 caracteres')
      .max(16, 'No máximo 16 caracteres')
      .test(
        'isValidPass',
        'A senha precisa ter no mínimo uma letra e um número e ter no mínimo 6 dígitos',
        (value) => {
          const hasUpperCase = /[A-Z]/.test(value);
          const hasLowerCase = /[a-z]/.test(value);
          const hasNumber = /[0-9]/.test(value);
          const numberOfMustBeValidConditions = 2;
          const conditions = [hasLowerCase || hasUpperCase, hasNumber];
          const condicoesAtendidas = conditions.filter(
            (condition) => condition
          );

          if (condicoesAtendidas.length >= numberOfMustBeValidConditions) {
            return true;
          }
          return false;
        }
      ),
    senha2: string()
      .required('A senha é obrigatória')
      .min(6, 'No mínimo 6 caracteres')
      .max(16, 'No máximo 16 caracteres')
      .test(
        'isValidPass',
        'A senha precisa ter no mínimo uma letra e um número e ter no mínimo 6 dígitos',
        (value) => {
          const hasUpperCase = /[A-Z]/.test(value);
          const hasLowerCase = /[a-z]/.test(value);
          const hasNumber = /[0-9]/.test(value);
          const numberOfMustBeValidConditions = 2;
          const conditions = [hasLowerCase || hasUpperCase, hasNumber];
          const condicoesAtendidas = conditions.filter(
            (condition) => condition
          );

          if (condicoesAtendidas.length >= numberOfMustBeValidConditions) {
            return true;
          }
          return false;
        }
      ),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        senha1: '',
        senha2: '',
      }}
      validationSchema={matriculaSchema}
      onSubmit={async (values, { setSubmitting }) => {
        await submitMatricula(values);
        setSubmitting(false);
      }}
    >
      {({ handleSubmit, isSubmitting, isValid }) => (
        <form onSubmit={handleSubmit}>
          <Field
            className="mb-3"
            iconChangeType
            name="senha1"
            large
            component={TextInput}
            label="Digite a nova senha"
          />
          <Field
            className="mb-32 mt-32"
            iconChangeType
            name="senha2"
            large
            component={TextInput}
            label="Repita a senha digitada"
          />
          <p className="d-block text-center mb-3 mt-2 ts-14 fw-bold text-red">
            {senhasDivergentes}
          </p>
          <Button
            className="mt-32 ts-14"
            large
            disabled={isSubmitting || !isValid}
            onClick={handleSubmit}
          >
            Alterar senha
          </Button>
        </form>
      )}
    </Formik>
  );
};
